<template>
  <div class="app-container">
    <list ref="list">
      <template slot="column" v-if="$permission.canWrite()">
        <el-table-column label="操作" fixed="right" align="center" width="85">
          <template slot-scope="{row}">
            <el-button type="text" @click="check(row)">审核</el-button>
            <el-button type="text" @click="delRows(row.WithdrawCashId)">删除</el-button>
          </template>
        </el-table-column>
      </template>
    </list>
    <edit-dialog ref="editDialog" @close-saved="reload" />
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import list from "@/components/sales/customer/withdraw/list";
import editDialog from "@/components/sales/customer/withdraw/editDialog";

export default {
  name: "withdraw",
  mixins: [curdMixins],
  components: {
    list,
    editDialog,
  },
    data() {
    return {
      api: require("@/api/ba/withdrawcash").default,
    };
  },
  methods: {
    check(row) {
      sessionStorage.setItem('check','1')
      this.editById(row.WithdrawCashId)
    },
   delRows(id) {
    this.$confirm("确认删除数据吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(() => {
        this.api.delete({id:id}).then(res => {
          if(res.Code ==0) {
            this.$message.success("删除成功")
            this.$refs.list.reload();
          } else {
            this.$message.error(res.Msg)
          }
        })
      })
      .catch(() => {});
    },
    
  },
};
</script>